export default __webpack_public_path__ + "static/media/nor_4.f24c3025.svg";